import dayjs from 'dayjs';

/**
 * @param a
 * @param b
 */
export function stringSorter(a, b) {
	return String(a).toLowerCase().localeCompare(String(b).toLowerCase());
}

/**
 * @param a
 * @param b
 */
export function intSorter(a, b) {
	return Number.parseFloat(a) - Number.parseFloat(b);
}

export const emailSorter = (a, b) => stringSorter(a, b);

export const dateSorter = (a, b) => dayjs(a).diff(b, 'millisecond');
